import { Outlet, useLocation } from "react-router-dom";
import { useState } from "react";
import { useQueryClient } from "react-query";
import toast from "react-hot-toast";
import Header from "./Header";
import { useConfig } from "../hooks/useApi";

export function RootLayout() {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const queryClient = useQueryClient();
  const location = useLocation();

  useConfig();

  const showActions = !location.pathname.startsWith("/changelog/");

  const handleRefresh = () => {
    setIsRefreshing(true);
    toast
      .promise(queryClient.invalidateQueries(), {
        loading: "Atualizando…",
        success: "Atualizado",
        error: "Erro ao atualizar",
      })
      .finally(() => setIsRefreshing(false));
  };

  return (
    <div className="min-h-screen flex flex-col text-foreground">
      <a href="#main" className="skip-link">
        Pular para o conteúdo
      </a>

      <Header
        onRefresh={handleRefresh}
        isRefreshing={isRefreshing}
        showActions={showActions}
      />

      <main
        id="main"
        tabIndex={-1}
        className="flex-1 w-full max-w-5xl mx-auto px-5 sm:px-8 lg:px-12 py-12 sm:py-16"
      >
        <Outlet />
      </main>

      <footer className="border-t border-border mt-16">
        <div className="max-w-5xl mx-auto px-5 sm:px-8 lg:px-12 py-8 flex flex-col sm:flex-row gap-2 sm:gap-4 sm:items-center sm:justify-between text-sm text-muted-foreground">
          <p>
            Mantido pela{" "}
            <a
              href="https://takeflow.com.br"
              target="_blank"
              rel="noopener noreferrer"
              className="text-foreground hover:text-primary underline-offset-4 hover:underline transition-colors"
            >
              Takeflow
            </a>
            .
          </p>
          <p className="text-muted-foreground/60 tabular-nums">
            &copy; {new Date().getFullYear()}
          </p>
        </div>
      </footer>
    </div>
  );
}
